import { Play, Target } from 'lucide-react';
import { ContentRail } from './ContentRail';
import { formatDuration } from '../../utils/homeHelpers';

export function HighlightsSection({ highlightsContent, navigate, onPlayVideo }) {
  if (!highlightsContent.length) return null;

  return (
    <ContentRail
      icon={<Target className="w-5 h-5 text-yellow-500 shrink-0" />}
      title="Latest Highlights"
      subtitle="Goals, saves, and best moments"
      seeAllPath="/highlights"
      navigate={navigate}
      testId="highlights-section"
    >
      {highlightsContent.map((content) => (
        <div
          key={content.id}
          onClick={() => {
            if (content.source === 'youtube' && content.youtube_video_id) onPlayVideo(content);
            else navigate(`/match/${content.id}`);
          }}
          className="flex-shrink-0 w-[260px] sm:w-[300px] cursor-pointer group snap-start"
          data-testid={`highlight-card-${content.id}`}
        >
          <div className="relative aspect-video rounded-xl overflow-hidden mb-2.5">
            <img src={content.thumbnail_url} alt={content.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            <div className="absolute top-2 left-2 flex items-center gap-1">
              <div className="flex items-center gap-1 px-1.5 py-0.5 bg-yellow-500 text-black text-[9px] font-bold rounded">
                <Target className="w-2.5 h-2.5" />
                HIGHLIGHT
              </div>
            </div>
            {content.competition_name && (
              <div className="absolute top-2 right-2 px-1.5 py-0.5 bg-black/60 backdrop-blur-sm border border-white/10 rounded-full">
                <span className="text-emerald-400 text-[8px] font-bold uppercase tracking-wider">{content.competition_name}</span>
              </div>
            )}
            {content.duration && (
              <div className="absolute bottom-2 right-2 px-1.5 py-0.5 bg-black/80 text-white text-[9px] font-medium rounded">{formatDuration(content.duration)}</div>
            )}
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="w-11 h-11 bg-yellow-500 rounded-full flex items-center justify-center shadow-lg">
                <Play className="w-4 h-4 text-black" fill="currentColor" />
              </div>
            </div>
          </div>
          <h3 className="text-white font-semibold text-sm group-hover:text-yellow-500 transition-colors line-clamp-2">{content.teams || content.title}</h3>
          <p className="text-gray-500 text-xs mt-0.5 line-clamp-1">
            {content.duration ? formatDuration(content.duration) : ''}
            {content.competition_name ? ` \u00B7 ${content.competition_name}` : ''}
          </p>
        </div>
      ))}
    </ContentRail>
  );
}
